(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./index.less", "./constant"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./index.less"), require("./constant"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.index, global.constant);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _index, _constant) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        staticClass: "nx-steps--box"
      }, [_vm._t("default")], 2);
    },
    name: 'nx-steps',
    props: {
      value: {
        type: Number,
        default: 0
      }
    },
    data: function data() {
      return {
        current: 0
      };
    },
    watch: {
      value: function value(val) {
        this.current = val;
      },
      current: function current(val) {
        this.mapPropsToChildren();
        this.$emit('input', val);
      }
    },
    methods: {
      mapPropsToChildren: function mapPropsToChildren() {
        var _this = this;

        var len = this.$children.length - 1;
        this.$children.forEach(function (item, idx) {
          item.currentStepNumber = (idx + 1).toString();
          item.currentStepLast = idx === len;

          if (idx === _this.current) {
            item.currentStatus = _constant.STEPS_ITEM_STATUS.PROCESS;
          } else if (idx < _this.current) {
            item.currentStatus = _constant.STEPS_ITEM_STATUS.FINISH;
          } else {
            item.currentStatus = _constant.STEPS_ITEM_STATUS.WAIT;
          }
        });
      }
    },
    created: function created() {
      this.current = this.value;
    },
    mounted: function mounted() {
      this.mapPropsToChildren();
    }
  };
  _exports.default = _default;
});